import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client/core';

const RESCHEDULE_APPOINTMENT = gql`
  mutation RescheduleAppointment(
    $appointmentUid: String!
    $input: RescheduleAppointmentInput!
    $allowUnbookableTime: Boolean!
  ) {
    rescheduleAppointment(
      appointmentUid: $appointmentUid
      input: $input
      allowUnbookableTime: $allowUnbookableTime
    ) {
      uid
      status
      startTime
      status
      comment
      sellerService {
        uid
        name
        color
        durationInMinutes
      }
      buyer {
        uid
        formalName
        phone
      }
    }
  }
`;

export const useRescheduleAppointment = () => {
  const [rescheduleAppointmentMutation] = useMutation(RESCHEDULE_APPOINTMENT); // Destructure error from useMutation

  const handleRescheduleAppointment = async (input) => {
    try {
      const response = await rescheduleAppointmentMutation({
        variables: {
          appointmentUid: input?.appointmentUid,
          input: input?.input,
          allowUnbookableTime: input?.allowUnbookableTime || false,
        },
      });
      return response;
    } catch (err) {
      console.error('Error rescheduling appointment:', err);

      // Check for GraphQL errors
      if (err.graphQLErrors && err.graphQLErrors.length > 0) {
        // Handle GraphQL errors
        return err.graphQLErrors[0]?.message;
        // You can choose to handle specific error codes or messages here
        // For instance, you can throw a custom error or return a specific response
      }

      // Check for network errors
      if (err.networkError) {
        // Handle network errors
        console.error('Network error:', err.networkError);
        // You can choose to handle network errors differently
        // For instance, you can throw a custom error or return a specific response
      }

      // Handle the error appropriately (e.g., display a user-friendly message)
      return null; // Or throw a custom error for further handling
    }
  };

  return handleRescheduleAppointment;
};
